var _path, _path2, _rect, _path3, _rect2, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsumer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    fill: "none",
    viewBox: "0 0 14 15",
    className: "header__nav-link-icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.917c.222.221-.062.274.812.799m-3.145-.8c-.106.213-.459.474-.875.723m0 0c-.498.297-1.088.577-1.458.736-1.75.875-1.75 3.792-1.75 4.958H3.5m.292-5.694s.871 1.63 2.041 1.611c1.132-.02 1.98-1.534 1.98-1.534m0 0c.276.166.96.379 1.52.659.866.433 1.305 1.217 1.527 2.079",
    stroke: "#323657"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.917 13.333v-1.75",
    stroke: "#323657",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.417,
    y: 1,
    width: 4.833,
    height: 6,
    rx: 2.417,
    stroke: "#323657"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.792 2.542c.15.563 1.75 2.333 4.18.401",
    stroke: "#323657"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 10.333,
    width: 6,
    height: 3.667,
    rx: 1.5,
    stroke: "#323657"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 2.833h2.333",
    stroke: "#323657",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumer);
export default __webpack_public_path__ + "static/media/Consumer.2516f4baa6923836d1ac1a5987e8cb8e.svg";
export { ForwardRef as ReactComponent };